module.exports = __webpack_public_path__ + "static/media/S33_B.85e25009.png";